export default "__VITE_ASSET__29fbee2d__"